export * from './ngxChart.component';
